import React, { useEffect } from "react";
import AOS from "aos";
import services from "../../api/services";
import SectionTitle from "../SectionTitle/SectionTitle";
import ServiceCard from "./ServiceCard";
import ShapeOn from "../../images/services/service-1.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ServiceSection = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className={"section-padding " + props.hclass}>
      <div className="top-img">
        <img src={ShapeOn} alt="Services Backgoround CreaSnap" loading="lazy" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12" data-aos="fade-down">
            <SectionTitle
              title="Rancang Konsep Ide Bisnis Anda Sekarang"
              subtitle="Layanan Kami"
            />
          </div>
        </div>
        <div className="services-wrap">
          <div className="row">
            <div className="services-slider" data-aos="fade-left">
              <Slider {...settings}>
                {services.length > 0 &&
                  services.map((item, sindx) => (
                    <ServiceCard
                      key={sindx}
                      title={item.title}
                      img={item.img}
                      id={item.id}
                      sdescription={item.description}
                    />
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
